export default __webpack_public_path__ + "static/media/Vertesszolos.eb43511a.png";